// angular
// 	.module("HeroPRO")
// 	.controller("WalkthroughController", walkthroughController);

import './walkthrough.scss';

/* @ngInject */
export default function walkthroughController($scope, HPStateMachineConfig, FRInformationFactory, FRClosingFactory, FRDocumentsFactory, WalkthroughFactory, HPConditionTypes, PermissionsFactory) {
    const vm = this;
    vm.HPStateMachineConfig = HPStateMachineConfig;
    vm.appInfo = {};
    vm.activeWalkthroughTemplate = '';
    vm.stateMachineData = {};
    vm.isFundingScheduled = false;
    vm.showGetSignaturesButton = false;
    vm.outstandingDocuments = [];
    vm.invalidDocuments = [];
    vm.HPConditionTypes = HPConditionTypes;
    vm.isSolicitor = PermissionsFactory.hasPermission('IsSolicitor');

    init();

    /*= =======================================
	 =            Public Functions            =
 	======================================== */
    vm.setCompletionCertificateRegenerated = function (newValue) {
        FRDocumentsFactory.setCompletionCertificateRegenerated(newValue);
        // Refresh the walkthrough since CompletionCertificateRegenerated is one of the values used to determine the active walkthrough
        WalkthroughFactory.loadWalkthrough();
    };

    vm.isProjectApproved = function () {
        return (vm.stateMachineData.FundingRequestStateId === vm.HPStateMachineConfig.FR.HERO_Funding_Scheduled || vm.stateMachineData.FundingRequestStateId === vm.HPStateMachineConfig.FR.HLP_Recording_Scheduled) && vm.isFundingScheduled;
    };
    /* -----  End of Public Functions  ------*/

    /*= ========================================
	 =            Private Functions            =
	 ========================================= */
    function init() {
        // Set the initial walkthrough that is shown
        WalkthroughFactory.loadWalkthrough().then(() => {
            vm.activeWalkthroughTemplate = WalkthroughFactory.getActiveWalkthroughTemplate();

            // Watch for changes to the activeWalkthroughTemplate that occur as the user processes a loan (w/o refreshing the page)
            $scope.$watch(WalkthroughFactory.getActiveWalkthroughTemplate, (newTemplate) => {
                vm.activeWalkthroughTemplate = newTemplate;
            });
        });

        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            vm.stateMachineData = FRInformationFactory.getStateMachineData();
            vm.appInfo = FRInformationFactory.getAppInfo();
        });

        FRClosingFactory.getFundingRequestClosingPromise().then(() => {
            vm.isFundingScheduled = FRClosingFactory.getIsFundingScheduled();
        });

        FRDocumentsFactory.getFundingRequestDocumentsPromise().then(() => {
            vm.showGetSignaturesButton = FRDocumentsFactory.getSignaturesButtonVisibility();
            vm.outstandingDocuments = FRDocumentsFactory.getOutstandingDocuments();
            vm.invalidDocuments = FRDocumentsFactory.getInvalidDocuments();
        });
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/walkthroughController.js